export default "__VITE_ASSET__gNXidksR__"